import type { FaireProductEntity } from "../../entity_types/product";

export const p_agzunajzy6: FaireProductEntity = {
  token: "p_agzunajzy6",
  type: "product",
  name: "ZaZa Za'atar Pita Chips",
  brandToken: "b_9fsdrgr4qg",
  brandName: "ZaZa Snacks",
  imageUrl:
    "https://cdn.faire.com/fastly/824fefa1ed489ed05f1f025843ce52a053c4311bf0e13a1e324477864ab97e75.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3fab49242813b7e7d4ff6c9247e126faaf7e184868decb4002e1090cd186b4ee.jpeg",
    "https://cdn.faire.com/fastly/b0f36415ed3ad9783c07d70aa5cb413065b1ce7a1b536cc32c9a8c07a5837b1a.jpeg",
    "https://cdn.faire.com/fastly/0aa8eace5fd0bca6496afa84bc01cc0802408cd02adc98fb536cde1eb84b9555.jpeg",
    "https://cdn.faire.com/fastly/0e8cfa02adb508f13ae2d78ac16462b2dc65873d02bd900f6ebd246c6262e6fc.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "ZaZa Za'atar Pita Chips are thin, crisp and baked in small batches with freshly baked pita bread, high-quality extra virgin olive oil, and a generous coating of our custom za'atar spice blend. It’s our flagship chip which is based on our favorite mother-in-law’s decades-old recipe. She’s the reason we call it “The Mother Chip”. Dip them into hummus, baba ganoush, or labne, toss into salads, or enjoy them on their own.",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:15.624Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
